import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CalendarDay } from './MyIbeCalendarDay';
export const MyIbePropertyView = (props) => {
    const { property, days, dayOptions, onDayClick, onDayHover, imageBaseUrl } = props;
    const backgroundImage = ((property.images.length > 0)
        ? `url("${imageBaseUrl}/${property.images[0].path}")`
        : undefined);
    return (_jsxs("div", { className: "ibe-property-calendar", children: [_jsx("div", { className: "ibe-property", style: { backgroundImage: backgroundImage }, children: _jsx("h3", { children: property.name }) }), _jsx("div", { className: "ibe-calendar ibe-property-view", children: _jsx("div", { className: "ibe-calendar-weeks", children: days.map(day => {
                        const date = { ...day };
                        const options = dayOptions(date);
                        return (_jsx(CalendarDay, { day: date, onClick: onDayClick, onHover: onDayHover, options: options }, `day-${date.date}`));
                    }) }) })] }));
};
//# sourceMappingURL=MyIbePropertyView.js.map